import { Modal, Typography, Button } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import dangerIcon from 'assets/danger.svg'

const ConfirmModal = (props) => {
    return (
        <Modal
            open={props?.open}
            onClose={() => props?.onClose()}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Box sx={{ display: "flex", flexDirection: "column", minWidth: { xs: "12rem", md: "17.06rem" }, justifyContent: "center", alignItems: "center", padding: 4, backgroundColor: 'white', borderRadius: "12px" }}>
                <img src={dangerIcon} />
                <Typography sx={{ fontSize: "16px", color: "#000000", textAlign: "center", marginTop: "-15px", marginBottom: "10px" }} variant="h8">Are You Sure! <br />
                    You Want To Terminate</Typography>
                <Box sx={{ display: "flex", gap: 2 }}>
                    <Button
                        sx={{
                            borderRadius: 4,
                            minWidth: 90,
                            minHeight: 42,
                            background: "#737D86",
                            marginTop: "13px",
                            "&:hover": {
                                backgroundColor: "#737D86",
                            },
                        }}
                        variant="contained"
                        type="button"
                        onClick={() => props?.onClose()}
                    >NO
                    </Button>
                    <Button
                        sx={{
                            borderRadius: 4,
                            minWidth: 90,
                            minHeight: 42,
                            background: "#EF7D00",
                            marginTop: "13px",
                            "&:hover": {
                                backgroundColor: "#EF7D00",
                            },
                        }}
                        variant="contained"
                        type="button"
                        onClick={() => props?.handleCancelConfirm()}
                    >YES
                    </Button>
                </Box>

            </Box>
        </Modal>
    )
}

export default ConfirmModal;
